module.exports = __webpack_public_path__ + "static/img/bg1_01.cbceccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/bg1_01.png
// module id = mX3n
// module chunks = 70